export default __webpack_public_path__ + "static/media/redis.f9d33a05.svg";